import { c as _c } from "react/compiler-runtime";
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { Dropdown, useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type SupportLinksSelectProps = {
  config?: OnboardingSessionConfig;
};
const SupportLinksSelect = t0 => {
  const $ = _c(31);
  const {
    config
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.components.footer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const {
    toast
  } = useToast();
  let t2;
  if ($[1] !== t || $[2] !== toast) {
    t2 = phoneNumber => {
      navigator.clipboard.writeText(phoneNumber);
      toast({
        title: t(_temp),
        description: t(_temp2)
      });
    };
    $[1] = t;
    $[2] = toast;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const copyToClipboard = t2;
  const sendEmail = _temp3;
  const openLink = _temp4;
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp5);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Dropdown.Trigger asChild={true}><div className="no-underline text-secondary hover:underline hover:underline-offset-2 hover:decoration-2 text-caption-1">{t3}</div></Dropdown.Trigger>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp6);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = config?.supportEmail;
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = {
      label: t5,
      contactLink: t6,
      type: "email",
      onSelect: sendEmail
    };
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp7);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = config?.supportPhone;
  let t10;
  if ($[15] !== copyToClipboard || $[16] !== t8 || $[17] !== t9) {
    t10 = {
      label: t8,
      contactLink: t9,
      type: "phone",
      onSelect: copyToClipboard
    };
    $[15] = copyToClipboard;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t(_temp8);
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = config?.supportWebsite;
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = {
      label: t11,
      contactLink: t12,
      type: "website",
      onSelect: openLink
    };
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t13 || $[26] !== t7) {
    t14 = <Dropdown.Content sideOffset={8}>{[t7, t10, t13].filter(_temp9).map(_temp10)}</Dropdown.Content>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t7;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14 || $[29] !== t4) {
    t15 = <Dropdown.Root>{t4}{t14}</Dropdown.Root>;
    $[28] = t14;
    $[29] = t4;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};
export default SupportLinksSelect;
function _temp($) {
  return $.links.support.phone["toast-success"].title;
}
function _temp2($_0) {
  return $_0.links.support.phone["toast-success"].description;
}
function _temp3(email) {
  window.open(`mailto:${email}`, "_blank");
}
function _temp4(link) {
  window.open(link, "_blank");
}
function _temp5($_1) {
  return $_1.links.support.label;
}
function _temp6($_2) {
  return $_2.links.support.email.label;
}
function _temp7($_3) {
  return $_3.links.support.phone.label;
}
function _temp8($_4) {
  return $_4.links.support.website.label;
}
function _temp9(t0) {
  const {
    contactLink
  } = t0;
  return contactLink;
}
function _temp10(t0) {
  const {
    label,
    contactLink: contactLink_0,
    onSelect
  } = t0;
  return <Dropdown.Item size="compact" key={label} onSelect={() => onSelect(contactLink_0)}>{label}</Dropdown.Item>;
}